import React from 'react';
import styled from 'styled-components';

import { makeStyles } from '@material-ui/core/styles';

import { Checkbox as WoboCheckbox } from '@workboard/wobo-ui';

const useStyles = makeStyles(() => ({
  root: {
    '& .Mui-checked': {
      '& span': {
        '& svg': {
          '& path': {
            d: "path('M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z')",
          },
        },
      },
    },
  },
}));

const RescaledCheckbox = styled(WoboCheckbox)`
  span {
    svg {
      transform: scale(1.25);
    }
  }
`;

const Checkbox = React.forwardRef(
  (props, ref: React.Ref<HTMLElement>): JSX.Element => {
    const classes = useStyles();

    // @ts-ignore
    return <RescaledCheckbox ref={ref} className={classes.root} {...props} />;
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
